import React from 'react'

const RadioIcon = () => {
  return (
    <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.04274 14.7913C1.83568 14.5842 1.73651 14.3452 1.73611 14.0553V5.72223C1.73611 5.49957 1.79504 5.30736 1.91127 5.13544L1.6705 4.97267L1.91127 5.13543C2.02749 4.96352 2.18187 4.83988 2.38366 4.76078L2.38367 4.7608L2.38787 4.7591L10.8473 1.31513L11.0441 1.81451L5.63325 4.01163L5.76389 4.68056H13.8889C14.1779 4.68056 14.4169 4.77951 14.6246 4.98719C14.8323 5.19487 14.9309 5.43351 14.9306 5.7218V5.72223V14.0556C14.9306 14.3448 14.8317 14.5839 14.6244 14.7915C14.4174 14.9988 14.1788 15.0976 13.8893 15.0972H13.8889H2.77777C2.48856 15.0972 2.24984 14.9984 2.04274 14.7913L1.79855 15.0355L2.04274 14.7913ZM2.43055 14.0556V14.4028H2.77777H13.8889H14.2361V14.0556V9.19445V8.84723H13.8889H2.77777H2.43055V9.19445V14.0556ZM2.43055 7.80556V8.15278H2.77777H11.1111H11.4583V7.80556V6.76389H12.1528V7.80556V8.15278H12.5H13.8889H14.2361V7.80556V5.72223V5.375H13.8889H2.77777H2.43055V5.72223V7.80556ZM6.54267 12.6121C6.27387 12.8809 5.95206 13.0139 5.55555 13.0139C5.15905 13.0139 4.83723 12.8809 4.56844 12.6121C4.29964 12.3433 4.16666 12.0215 4.16666 11.625C4.16666 11.2285 4.29964 10.9067 4.56844 10.6379C4.83723 10.3691 5.15905 10.2361 5.55555 10.2361C5.95206 10.2361 6.27387 10.3691 6.54267 10.6379C6.81146 10.9067 6.94444 11.2285 6.94444 11.625C6.94444 12.0215 6.81146 12.3433 6.54267 12.6121Z"
      fill="#BF740A"
      stroke="#BF740A"
      strokeWidth="0.694444"
    />
  </svg>
  )
}

export default RadioIcon